import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//
import TemaProvider from './context/Tema';
//
import Faturas from './pages/Faturas';

function App() {
  return (
    <TemaProvider>
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        draggable
        theme="colored"
      />
      <Faturas />
    </TemaProvider>
  );
}

export default App;
